<template>
  <div class="distribution-map-main">
    <el-container>
      <el-aside width="200px">
        <ul class="checkbox-container">
          <li v-for="(item,index) in venueArr">
            <el-checkbox v-model="item.show" :label="item.label" border></el-checkbox>
          </li>
        </ul>
      </el-aside>
      <el-main>
        <div class="image-container">
          <img :src="'static/images/venue/distributionMap/'+bgName+'.png'"/>
          <img v-for="(item,index) in venueArr" v-show="item.show"
               :src="'static/images/venue/distributionMap/'+bgName+'_'+item.sign+'.png'" class="img-sign"/>
          <img v-for="(item,index) in venueArr" v-show="item.show&&showMapLabel"
               :src="'static/images/venue/distributionMap/'+bgName+'_'+item.sign+'_l.png'" class="img-sign"/>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  export default {
    props: {
      venueArr: {
        required: true
      },
      bgName: {
        required: true
      },
      showMapLabel: {
        default: true
      }
    },
    data () {
      return {}
    },
    components: {},
    mounted () {
      this.$nextTick(function () {

      })
    },
    methods: {}
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/venue/DistributionMapContent.vue